import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageSettings } from '@/models'

interface GetPackagesSettingsRequest {
  buildingId: number
}

export const PACKAGES_SETTINGS_BASE_QUERY_KEY = 'useGetPackagesSettings'

export const getPackagesSettingsQueryKey = (data: GetPackagesSettingsRequest) => [
  PACKAGES_SETTINGS_BASE_QUERY_KEY,
  data,
]

export const getPackagesSettings = async (
  params: GetPackagesSettingsRequest,
): Promise<PackageSettings> => {
  const response = await authAPI.get<PackageSettings>(`/packages/settings`, { params })
  return response.data
}

export const useGetPackagesSettings = (data: GetPackagesSettingsRequest) => {
  return useQuery({
    enabled: data.buildingId > 0,
    queryFn: () => getPackagesSettings(data),
    queryKey: getPackagesSettingsQueryKey(data),
  })
}
